<div *ngIf="InvoiceDetailForm">
  <div [formGroup]="InvoiceDetailForm" class="section container-fluid col-md-11 justify-content-center" fxLayoutGap="grid">

    <div class="innertitletxt">
      Détail du bon à payer
    </div>

    <div class="card">
      <div class="card-body">

        <div fxLayout="column">

          <!-- Facture n° / Societe metadonnées -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
            <ng-container>
              <div fxFlex="50" fxLayoutGap="10px">
                <div fxFlex="50">
                  <ng-container *ngTemplateOutlet="TemplateinvoiceNumberReadOnlyNew"></ng-container>
                </div>
                <div fxFlex="50">
                  <ng-container *ngTemplateOutlet="TemplateAssignmentGroupName"></ng-container>
                </div>
              </div>
              <div fxFlex="50">
                <ng-container *ngTemplateOutlet="TemplatesupplierRecipientNameNew"></ng-container>
              </div>
            </ng-container>
          </div>

          <!-- Siret / Siren / Société -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
            <div fxFlex="50" fxFlex.gt-sm="50" fxLayoutGap="10px">
              <ng-container *ngTemplateOutlet="TemplateSocieteSIRENSIRET"></ng-container>
            </div>
            <div fxFlex="50" fxFlex.gt-sm="50">
              <ng-container *ngTemplateOutlet="TemplateSociete"></ng-container>
            </div>
          </div>

          <!-- Raison sociale / Référence 1 / Référence 2 -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
            <div fxFlex="50" fxFlex.gt-sm="50">
              <ng-container *ngTemplateOutlet="TemplateRaisonSociale"></ng-container>
            </div>
          </div>

          <!-- Raison sociale eValua / Code ERP Sage / Groupe d'affectation -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
            <div fxFlex="50" fxLayoutGap="10px">
              <ng-container *ngTemplateOutlet="TemplateRaisonSocialeEvalua"></ng-container>
            </div>
            <div fxFlex="50" fxLayoutGap="10px">
              <ng-container *ngTemplateOutlet="TemplateInvoiceReferences"></ng-container>
            </div>
          </div>

          <!-- RCS / TVA Intra / Numéro de bon de commande / Type de facture / commentaire -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
            <div fxFlex="50" fxFlex.gt-sm="50" fxLayoutGap="10px">
              <ng-container *ngTemplateOutlet="TemplateRCSTVAIntra"></ng-container>
            </div>
            <div fxFlex="50">
              <ng-container *ngTemplateOutlet="TemplateVoucherDepartment"></ng-container>
            </div>
          </div>

          <!-- Date facture / Date échéance -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
            <div fxFlex="50" fxFlex.gt-sm="50" fxLayoutGap="10px">
              <ng-container *ngTemplateOutlet="TemplateDateInformations"></ng-container>
            </div>
            <div fxFlex="50">
              <ng-container *ngTemplateOutlet="TemplateVoucherAnalyticalSection"></ng-container>
            </div>
          </div>

          <!-- Montant HT / Montant TTC / Devise / Reverse Factoring -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
            <div fxFlex="50" fxLayoutGap="10px">
              <ng-container *ngTemplateOutlet="TemplateInvoiceAmount"></ng-container>
            </div>
            <div fxFlex="50">
              <ng-container *ngTemplateOutlet="TemplateVoucherAnalyticalCode"></ng-container>
            </div>
          </div>

          <!-- Commentaire voucher-->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start">
            <div fxFlex="50">
            </div>
            <div fxFlex="50">
              <ng-container *ngTemplateOutlet="TemplateVoucherComment"></ng-container>
            </div>
          </div>

        </div>

      </div>
    </div>



    <ng-template #TemplateinvoiceNumberReadOnlyNew>
      <mat-form-field floatLabel="always" appearance="outline">
        <mat-label>FACTURE N°</mat-label>
        <input matInput value="{{ InvoiceDetailModel.Number }}" type="text" readonly disabled>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateAssignmentGroupName>
      <mat-form-field floatLabel="always" appearance="outline">
        <mat-label>GROUPE D'AFFECTATION</mat-label>
        <input matInput value="{{ InvoiceDetailModel.CurrentAssignmentGroupName }}" type="text" readonly disabled>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplatesupplierRecipientNameNew>
      <mat-form-field floatLabel="always" appearance="outline">
        <mat-label>SOCI&Eacute;T&Eacute; M&Eacute;TADONN&Eacute;ES</mat-label>
        <input matInput value="{{ InvoiceDetailModel.SupplierRecipientName }}" type="text" readonly disabled>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateSocieteSIRENSIRET>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
        <mat-label>SIREN </mat-label>
        <input matInput value="{{ InvoiceDetailModel.SupplierSiren }}" type="text" readonly disabled>
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
        <mat-label>SIRET </mat-label>
        <input matInput value="{{ InvoiceDetailModel.SupplierSiret }}" type="text" readonly disabled>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateSociete>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" floatLabel="always">
        <mat-label>SOCI&Eacute;T&Eacute; </mat-label>
        <input matInput value="{{ InvoiceDetailModel.RecipientEntityName }}" type="text" readonly disabled>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateRaisonSociale>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
        <mat-label>RAISON SOCIALE </mat-label>
        <input matInput value="{{ InvoiceDetailModel.SupplierCompanyName }}" type="text" readonly disabled>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateRaisonSocialeEvalua>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
        <mat-label>RAISON SOCIALE EVALUA </mat-label>
        <input matInput value="{{ InvoiceDetailModel.SupplierEvaluaCompanyName }}" type="text" readonly disabled>
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50">
        <mat-label>CODE ERP SAGE </mat-label>
        <input matInput value="{{ InvoiceDetailModel.SupplierSageErpCode }}" type="text" readonly disabled>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateInvoiceReferences>
      <mat-form-field floatLabel="always" floatLabel="always" appearance="outline" fxFlex="50">
        <mat-label> R&Eacute;F&Eacute;RENCE 1 </mat-label>
        <input matInput value="{{ InvoiceDetailModel.PrimaryReference }}" type="text" readonly disabled>
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
        <mat-label>R&Eacute;F&Eacute;RENCE 2</mat-label>
        <input matInput value="{{ InvoiceDetailModel.SecondaryReference }}" type="text" readonly disabled>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateRCSTVAIntra>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
        <mat-label>RCS</mat-label>
        <input matInput value="{{ InvoiceDetailModel.SupplierRcsNumber }}" type="text" readonly disabled>
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
        <mat-label>TVA INTRA </mat-label>
        <input matInput value="{{ InvoiceDetailModel.SupplierVatNumber }}" type="text" readonly disabled>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateDateInformations>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
        <mat-label>DATE FACTURE </mat-label>
        <input matInput value="{{ InvoiceDetailModel.IssuedAt }}" type="text" readonly disabled>
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="50" fxFlex.gt-sm="50">
        <mat-label>DATE &Eacute;CH&Eacute;ANCE</mat-label>
        <input matInput value="{{ InvoiceDetailModel.DueDate }}" type="text" readonly disabled>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateInvoiceAmount>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="25" fxFlex.gt-sm="25">
        <mat-label>MONTANT HT </mat-label>
        <input matInput value="{{ InvoiceDetailModel.AmountTaxExcluded }}" type="text" pattern="[-]?[0-9\s+]+(?:[,\.][0-9]{0,2})?" step="0.01" readonly disabled>
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="25" fxFlex.gt-sm="25">
        <mat-label>MONTANT TTC </mat-label>
        <input matInput value="{{ InvoiceDetailModel.AmountTaxIncluded }}" type="text" pattern="[-]?[0-9\s+]+(?:[,\.][0-9]{0,2})?" step="0.01" readonly disabled>
      </mat-form-field>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="25" fxFlex.gt-sm="25">
        <mat-label>DEVISE</mat-label>
        <input matInput value="{{ InvoiceDetailModel.Currency }}" type="text" readonly disabled>
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateVoucherDepartment>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
        <mat-label>DIRECTION</mat-label>
        <input matInput formControlName="VoucherDepartment" type="text">
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateVoucherAnalyticalSection>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
        <mat-label>SELECTION ANALYTIQUE</mat-label>
        <input matInput formControlName="VoucherAnalyticalSection" type="text">
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateVoucherAnalyticalCode>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
        <mat-label>CODE PROJET</mat-label>
        <input matInput formControlName="VoucherAnalyticalCode" type="text">
      </mat-form-field>
    </ng-template>

    <ng-template #TemplateVoucherComment>
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
        <mat-label>COMMENTAIRE</mat-label>
        <textarea matInput formControlName="VoucherComment" type="text" placeholder="" rows="3" maxlength="250"></textarea>
      </mat-form-field>
    </ng-template>
  </div>
</div>